type LogoMarkProps = {
  size?: number;
};

export function LogoMark({ size = 28 }: LogoMarkProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        background: 'var(--ink)',
        position: 'relative',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <svg width={size * 0.64} height={size * 0.64} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="7.5" stroke="#fff" strokeWidth="1.6" />
        <path
          d="M12 4.5 V12 L17 15"
          stroke="#fff"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
